<script>
export default {
	name: "SupportContacts",
	render() {
		return false;
	},
	mounted() {
		this.loadScript();
	},
	watch: {
		$route(n, o) {
			let vm = this;
			vm.toggleWidget(n);
		},
	},
	beforeDestroy() {
		this.destroyScript();
	},
	methods: {
		toggleWidget(route){
			let vm = this;

			let routesNamesToHideWidget = [
				"betslip"
			]

			if(vm.$store.getters.layout == 'Mobile'){
				let container = document.getElementsByClassName('contact-fab-container')
				if (
					routesNamesToHideWidget.includes(route.name)
				){
					container[0].classList.add("hide")
					container[0].classList.remove("show")
				}else{
					container[0].classList.add("show")
					container[0].classList.remove("hide")
				}
			}
		},
		loadScript() {
			let vm = this;
			let scriptLoader =  new Promise((resolve, reject) => {
				let src = vm.env.supportContactsTab.url;
				let id = "contact-fab-loader";
				let alignment = "right"
				if (
					document.getElementById(id) &&
					document.getElementById(id).src == src
				){
					return resolve(true);
				}
				let script = document.createElement("script");
				script.onload = () => resolve(true);
				script.id = id;
				script.src = src;
				script.setAttribute('data-align', alignment);

				document.head.appendChild(script);
			});

			scriptLoader.then(()=>{
				let container = document.getElementsByClassName('contact-fab-container')
				if(vm.$store.getters.layout == 'Mobile'){
					container[0].classList.add("padded-bottom")
				}else{
					container[0].classList.remove("padded-bottom")
				}
				vm.toggleWidget(vm.$route)
			});

		},
		destroyScript() {
			let id = "contact-fab-loader";
			let vm = this;
			let src = vm.env.supportContactsTab.url;

			const script = document.querySelector('script[src="'+src+'"]');
			if (script) {
				console.log("FOUND SCRIPT")
				script.remove();
			}

			const container = document.querySelector('.contact-fab-container');
			if (container) {
				console.log("FOUND CONTAINER")
				container.remove();
			}

		}
	},
};
</script>
<style lang="scss">

	.padded-bottom{
		bottom: 100px !important;
	}

	.hide{
		display: none;
	}

	show{
		display: unset;
	}

	.contact-fab-container{
		&.left, &.right{
			bottom: 10px;
		}
	}
</style>
